import { Box } from "@mui/material";
import { DashboardChip } from "./DashboardChip";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';

interface InspectionMissingChipProps {
    onClick?: () => void;
    isDeactivated?: boolean;
}

export const InspectionMissingChip = ({ onClick, isDeactivated }: InspectionMissingChipProps) => {
    return (
        <DashboardChip
            text={
                <Box display="flex" alignItems="center">
                    <HelpOutlineOutlinedIcon fontSize="small" />
                </Box>
            }
            icon={<SearchIcon />}
            backgroundColor="#F8B42A"
            borderColor="#F07E07"
            onClick={onClick}
            isDeactivated={isDeactivated}
        />
    );
};